<div class="switch-container" (click)="setValue(!ngModel)" [ngClass]="{'checked': ngModel}">
    <div class="background">
        <div class="toggle" [ngClass]="{'loading': !!spinnerId && Spinner.isShown(spinnerId)}"></div>
    </div>
</div>
